
import {LanguageTexts} from '../types'

export const Text: LanguageTexts = {   
  es:{
    'TitleLogin':'Autenticación',
    'DetailLogin':'Bienvenido, por favor ingrese su usuario y contraseña',
    'ButtonLogin':'Iniciar sesión',
    'UserName':'Usuario',
    'Password': 'Contraseña',
    'Location':'Sede',
    'LocationRequired':'La sede es un campo requerido',
    'UserRequired':'El usuario es requerido',
    'PasswordRequired':'La contraseña es requerida',
    'Error50Description':'Lo sentimos, ha ocurrido un error interno en el servidor. Nuestro equipo técnico ha sido notificado y estamos trabajando para solucionarlo lo antes posible. Por favor, intenta nuevamente más tarde. \nSi el problema persiste, no dudes en contactar a nuestro equipo de soporte para obtener asistencia adicional. Lamentamos las molestias que esto pueda causar.\n\nGracias por tu comprensión.'
  },
  en:{
    'TitleLogin':'Sign In',
    'DetailLogin':'Welcome, please enter your username and password',
    'ButtonLogin':'Log In',
    'UserName':'User name',
    'Password': 'Password',
    'Location':'Work location.',
    'LocationRequired':'Work location is a required field',
    'UserRequired':'User is a required field',
    'PasswordRequired':'Password is a required field',
    'Error50Description':'We\'re sorry, an internal server error has occurred. Our technical team has been notified, and we are working to resolve it as soon as possible. Please try again later.\nIf the issue persists, feel free to contact our support team for further assistance. We apologize for any inconvenience this may have caused.\n\nThank you for your understanding.'
  }
};